export default __webpack_public_path__ + "assets/wind-beaufort-4.e40e8ebd.svg";